const regex = /^.{5,60}$/; // 長度最小為 5, 最大為 60
const getMessage = (field) => `${field}長度不正確`;
const validate = (value) => regex.test(value);

/** 自訂驗證地址長度 */
export default {
  getMessage,
  validate,
};
